import React from 'react';
import {Form} from 'react-bootstrap';

/**
 * Renders username + password fields for charger types that need credentials.
 */
const CredentialsFields = ({formData, onChange}) => (
  <>
    <Form.Group>
      <Form.Label>Username</Form.Label>
      <Form.Control
        type="text"
        name="username"
        value={formData?.credentials?.username || ''}
        onChange={onChange}
      />
    </Form.Group>
    <Form.Group>
      <Form.Label>Password</Form.Label>
      <Form.Control
        type="password"
        name="password"
        value={formData?.credentials?.password || ''}
        onChange={onChange}
      />
    </Form.Group>
  </>
);

export default CredentialsFields;

